export default "__VITE_ASSET__16a71adb__"